import React, { Fragment, useEffect, useState } from "react";
import { Breadcrumbs, H4, H6 } from "../../AbstractElements";
import { Card, CardBody, Col, Row, Spinner } from "reactstrap";
import CountUp from "react-countup";
import { UserPlus, UserMinus, DollarSign, Shield } from "react-feather";
import { useSelector } from "react-redux";
import apiRequest from "../../utils/apiRequest";

const Dashboard = () => {
  const token = useSelector((state) => state.auth.userToken);

  const [stats, setStats] = useState({
    totalActiveUsers: 0,
    totalBlockedUsers: 0,
    totalSubAdmins: 0,
    blockedSubAdmins: 0,
    totalEarnings: 0,
    completedOrdersCount: 0,
    pendingOrdersCount: 0,
  });
  

  const [loading, setLoading] = useState(true);
  console.log("🚀 ~ Dashboard ~ stats:", stats)

  const fetchDashboardData = async () => {
    try {
      const [
        earningsResponse,
        activeUsersResponse,
        activeSubAdminsResponse,
        blockedUsersResponse,
        blockedSubAdminsResponse,
        completedOrdersResponse,
        pendingOrdersResponse
      ] = await Promise.all([
        apiRequest("get", `${process.env.REACT_APP_API_BASE_URL}/admin/totalEarning`, {}, token),
        apiRequest("get", `${process.env.REACT_APP_API_BASE_URL}/admin/active-users`, {}, token),
        apiRequest("get", `${process.env.REACT_APP_API_BASE_URL}/admin/active-subadmins`, {}, token),
        apiRequest("get", `${process.env.REACT_APP_API_BASE_URL}/admin/inactive-users`, {}, token),
        apiRequest("get", `${process.env.REACT_APP_API_BASE_URL}/admin/blocked-subadmins`, {}, token),
        apiRequest("get", `${process.env.REACT_APP_API_BASE_URL}/admin/completed-orders-count`, {}, token),
        apiRequest("get", `${process.env.REACT_APP_API_BASE_URL}/admin/pending-orders`, {}, token),
      ]);
  
      setStats({
        totalActiveUsers: activeUsersResponse.data.count,
        totalBlockedUsers: blockedUsersResponse.data.count,
        totalSubAdmins: activeSubAdminsResponse.data.count,
        blockedSubAdmins: blockedSubAdminsResponse.data.count,
        totalEarnings: earningsResponse.data.totalAmount,
        completedOrdersCount: completedOrdersResponse.data.completedOrdersCount,
        pendingOrdersCount: pendingOrdersResponse.data.pendingOrdersCount,
      });
  
      setLoading(false);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchDashboardData();
  }, [token]);

  if (loading) {
    return (
      <div className="text-center">
        <Spinner style={{ width: '3rem', height: '3rem' }} color="primary" />
      </div>
    );
  }

  return (
    <Fragment>
      <Breadcrumbs mainTitle="Dashboard" parent="Dashboard" />
      <Row>
        <Col xl="4" md="6">
          <StatsCard
            title="Total Active Users"
            value={stats.totalActiveUsers}
            icon={<UserPlus />}
            color="success"
          />
        </Col>
        <Col xl="4" md="6">
          <StatsCard
            title="Total Blocked Users"
            value={stats.totalBlockedUsers}
            icon={<UserMinus />}
            color="danger"
          />
        </Col>
        <Col xl="4" md="6">
          <StatsCard
            title="Total Sub Admins"
            value={stats.totalSubAdmins}
            icon={<Shield />}
            color="info"
          />
        </Col>
        <Col xl="4" md="6">
          <StatsCard
            title="Blocked Sub Admins"
            value={stats.blockedSubAdmins}
            icon={<UserMinus />}
            color="warning"
          />
        </Col>
        <Col xl="4" md="6">
  <StatsCard
    title="Total Earnings"
    value={stats.totalEarnings}
    icon={<DollarSign />}
    color="primary"
    isCurrency={true}
  />
</Col>

<Col xl="4" md="6">
    <StatsCard
      title="Completed Orders"
      value={stats.completedOrdersCount}
      icon={<DollarSign />} // Change the icon if necessary
      color="success"
    />
  </Col>
  <Col xl="4" md="6">
    <StatsCard
      title="Pending Orders"
      value={stats.pendingOrdersCount}
      icon={<DollarSign />} // Change the icon if necessary
      color="warning"
    />
  </Col>
      </Row>
    </Fragment>
  );
};

export default Dashboard;

const StatsCard = ({ title, value, icon, color, isCurrency }) => {
  return (
    <Card className={`bg-light-${color} text-${color}`}>
      <CardBody className="d-flex align-items-center justify-content-between">
        <div>
          <H6 className="mb-2">{title}</H6>
          <H4>
            {isCurrency ? (
              <>
                ${<CountUp end={value} duration={1} separator="," />}
              </>
            ) : (
              <CountUp end={value} duration={1} separator="," />
            )}
          </H4>
        </div>
        <div className="icon-wrapper">{icon}</div>
      </CardBody>
    </Card>
  );
};
